import { Controller } from "@hotwired/stimulus"

// Keeps the kanban board honest while cards move between columns via Turbo
// Streams: recounts each column and shows/hides its "no issues" placeholder.
export default class extends Controller {
  static targets = ["column"]

  connect() {
    this.observer = new MutationObserver(() => this.sync())
    this.columnTargets.forEach((column) => {
      this.observer.observe(column, { childList: true })
    })
    this.sync()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  sync() {
    this.columnTargets.forEach((column) => {
      const count = column.querySelectorAll("[data-issue-card]").length

      const counter = document.getElementById(`status_count_${column.dataset.status}`)
      if (counter) counter.textContent = count

      const placeholder = document.getElementById(`status_placeholder_${column.dataset.status}`)
      if (placeholder) placeholder.classList.toggle("hidden", count > 0)
    })
  }
}
